import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CirclePlayIcon } from 'lucide-react';
import { SmartLink } from './SmartLink';
import { isValidEmail } from '../hooks/useRequestDemoForm';
export function Hero() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!isValidEmail(email)) {
      setError(email.trim() ? 'Enter a valid email address' : 'Enter your work email to continue');
      return;
    }
    navigate(`/request-demo?email=${encodeURIComponent(email.trim())}`);
  }
  return <section data-nav-theme="dark" className="relative w-full overflow-x-clip" data-id="element-625" data-mp="ncgm0kvouzwd">
      <div className="mx-auto grid max-w-shell grid-cols-1 items-center gap-10 px-6 pb-16 pt-[120px] lg:min-h-[764px] lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-0 lg:pb-24 lg:pt-[144px]" data-id="element-626" data-mp="nekmstyajisf">
        <div className="relative z-10 max-w-[560px]" data-id="element-627" data-mp="384jq2q4e53op">
          <h1 className="display text-[44px] font-semibold text-white sm:text-[56px] lg:text-[68px]" data-id="element-628" data-mp="3j9kc5f0exnhp">
            Run your business with clarity and control.
          </h1>
          <p className="mt-6 max-w-[430px] text-[19px] leading-[1.45] text-white/80" data-id="element-629" data-mp="39al7s8moke0i">
            One place to manage sales, stock, customers, and the numbers that move your business forward.
          </p>

          <form className="mt-9 flex w-full max-w-[385px] items-center rounded-[10px] border border-white/20 bg-white p-1.5 shadow-[0_8px_24px_rgba(10,16,60,0.25)] focus-within:ring-2 focus-within:ring-white/40" noValidate onSubmit={handleSubmit} data-id="element-630" data-mp="30hhovkt9n8yh">
            <label htmlFor="hero-email" className="sr-only" data-id="element-631" data-mp="2viewp0ydwx7x">
              Work email
            </label>
            <input id="hero-email" type="email" value={email} onChange={e => {
            setEmail(e.target.value);
            if (error) setError('');
          }} autoComplete="email" aria-invalid={Boolean(error)} aria-describedby={error ? 'hero-email-error' : undefined} placeholder="Enter your work email" className="min-w-0 flex-1 bg-transparent px-3 py-2 text-[15px] text-ink outline-none placeholder:text-ink-muted" data-id="element-632" data-mp="2hix0w1mo8jp2" />
            <button type="submit" className="shrink-0 rounded-[7px] bg-brand px-4 py-2.5 text-[15px] font-semibold text-white transition-colors duration-150 ease-out hover:bg-brand-hover" data-id="element-633" data-mp="1b0vzrskljsju">
              Get started
            </button>
          </form>
          {error && <p id="hero-email-error" role="alert" className="mt-2 text-[14px] font-medium text-white" data-id="element-634" data-mp="x1nvwmdhnw9b">
              {error}
            </p>}

          <SmartLink href="/demo" className="mt-6 inline-flex items-center gap-2 text-[15px] font-medium text-white/90 transition-colors duration-150 ease-out hover:text-white" data-id="element-635" data-mp="3lquenodz0752">
            <CirclePlayIcon className="h-[18px] w-[18px]" aria-hidden="true" data-id="element-636" data-mp="1x7hvvdunc30v" />
            See Kayko in action
          </SmartLink>
        </div>

        <div className="relative flex items-center justify-center lg:absolute lg:inset-y-0 lg:left-[43%] lg:right-[-4%]" data-id="element-637" data-mp="268y69llgo553">
          <img src="https://cdn.magicpatterns.com/uploads/u85ioFqg7LTMidgQDirfqD/ChatGPT_Image_Sep_24,_2026,_12_52_14_PM.png" alt="Kayko dashboard on a tablet showing revenue, cash balance, recent activity, and best-selling products" className="w-full max-w-[760px] object-contain drop-shadow-[0_40px_60px_rgba(8,12,50,0.45)] lg:max-w-[980px]" data-id="element-638" data-mp="2b2agurtb2beu" />
        </div>
      </div>
    </section>;
}